module.exports = __webpack_public_path__ + "static/media/families.745514c1.jpg";